import React from "react";
import RequiredIndicator from "./RequiredIndicator";

const SectionHeader = (props) => {
	const { header, subHeader, required } = props;

	const styles = {
		container: {
			marginTop: "10px",
			color: "#3B3B3B"
		},
		header: {
			fontSize: "1.5rem"
		},
		subHeader: {
			fontSize: "1rem",
			fontStyle: "italic"
		},
		hrStyles: {
			background: "#d8d8d8"
		},
		line: {
			position: "relative",
			background:
				"url(data:image/svg+xml,%3Csvg%20version%3D%221.2%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20overflow%3D%22visible%22%20preserveAspectRatio%3D%22none%22%20viewBox%3D%220%200%20662%2013%22%20width%3D%22100%25%22%20height%3D%2213%22%3E%3Cg%20transform%3D%22translate%281%2C%201%29%22%3E%3Cline%20x1%3D%220%22%20y1%3D%225.5%22%20x2%3D%22660%22%20y2%3D%225.5%22%20stroke%3D%22%23d8d8d8%22%20stroke-width%3D%221%22%20stroke-linecap%3D%22%22%20stroke-dasharray%3D%22%22%20vector-effect%3D%22non-scaling-stroke%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E)",
			height: "11px"
		},
		dash: {
			backgroundColor: "#05C3DE",
			position: "absolute",
			top: "5px",
			left: 0,
			width: "30px",
			height: "4px"
		}
	};

	return (
		<div style={styles.container}>
			<div style={styles.header}>{header}</div>
			<div style={styles.subHeader}>{subHeader} {required && <RequiredIndicator />}</div>
			<div style={styles.line}>
				<div style={styles.dash}></div>
			</div>
		</div>
	);
};

SectionHeader.defaultProps = {
	inline: false
};

export default SectionHeader;
